import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg
        width={props.width ?? '24'}
        height={props.height ?? '24'}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.39461 4.55846C10.5463 2.54301 13.4519 2.54301 14.6036 4.55846L21.4347 16.5116C22.5773 18.5115 21.1326 20.9999 18.8292 20.9999H5.16903C2.86564 20.9999 1.42093 18.5115 2.56356 16.5116L9.39461 4.55846ZM11.9962 15.9969C11.4441 15.9971 10.9962 16.4448 10.9962 16.9969V17.4969C10.9962 18.0491 11.444 18.4968 11.9962 18.4969C12.5485 18.4969 12.9962 18.0492 12.9962 17.4969V16.9969C12.9961 16.4447 12.5484 15.9969 11.9962 15.9969ZM11.9962 7.49693C11.4441 7.49709 10.9962 7.9448 10.9962 8.49693V12.4969C10.9962 13.0491 11.444 13.4968 11.9962 13.4969C12.5485 13.4969 12.9962 13.0492 12.9962 12.4969V8.49693C12.9961 7.9447 12.5484 7.49693 11.9962 7.49693Z"
            fill={ds.colorValue.icon.primary}
        />
    </Svg>
);

export default SvgComponent;
